import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Formik } from 'formik'
import * as Yup from 'yup'

import { ProductIds } from 'core'
import terminateUser, {
  UserToTerminate,
} from 'core/application/adminDashboard/managePeople/viewPeople/terminateEmployee'

import { commandRequest } from 'common/RequestUtils'
import { Button, Col, DatePicker, Modal, Notification, Row } from 'common/components'
import { useCurrentProduct } from 'common/hooks'

const formValidator = (translate: (key: string) => string) =>
  Yup.object({
    terminationDate: Yup.date()
      .nullable()
      .typeError(translate('general.required'))
      .required(translate('general.required')),
  })

interface TerminateUserProps {
  visible: boolean
  userToTerminate: UserToTerminate
  onCancel: () => void
  afterSuccessTerminate: () => void
}

const TerminateUserModal: React.FC<TerminateUserProps> = (props) => {
  const { t: translate } = useTranslation('translation')
  const [loading, setLoading] = useState<boolean>(false)
  const [isFormValid, setIsFormValid] = useState<boolean>(false)
  const currentProduct = useCurrentProduct()

  let submitFormHandler: () => Promise<any> = () => new Promise(() => {})

  const onSubmit = async (values: UserToTerminate) => {
    setLoading(true)
    const result = await commandRequest(() => terminateUser(values))
    setLoading(false)

    if (!result.errors) {
      Notification.open({
        message: translate('admin-dashboard.manage-people.termination-success-header'),
        description: translate('admin-dashboard.manage-people.termination-success-desc'),
        type: 'success',
      })
      props.afterSuccessTerminate()
    } else {
      Notification.open({
        message: result.errors[0],
        type: 'error',
      })
    }
  }

  const modalFooterActions = [
    <Button key="back" onClick={props.onCancel}>
      {translate('general.cancel')}
    </Button>,
    <Button
      key="submit"
      className="danger"
      disabled={!isFormValid}
      loading={loading}
      onClick={() => submitFormHandler()}
    >
      {translate('admin-dashboard.manage-people.terminate')}
    </Button>,
  ]

  return (
    <Modal
      title={translate('admin-dashboard.manage-people.termination-alert-header').replace(
        '[First Last Name]',
        props.userToTerminate.fullName,
      )}
      visible={props.visible}
      destroyOnClose
      closable
      onCancel={props.onCancel}
      footer={modalFooterActions}
    >
      <div>
        <div>
          <span>{translate('admin-dashboard.manage-people.termination-alert-desc-1')}</span> <br />
          {currentProduct.productId === ProductIds.Perks
            ? translate('admin-dashboard.manage-people.termination-alert-desc-4')
            : translate('admin-dashboard.manage-people.termination-alert-desc-2')}
        </div>
        <div className="mt-16">{translate('admin-dashboard.manage-people.termination-alert-desc-3')}</div>
      </div>
      <div className="mt-16">
        <Formik
          enableReinitialize={true}
          validationSchema={formValidator(translate)}
          initialValues={props.userToTerminate}
          onSubmit={onSubmit}
          validate={(values) => {
            setIsFormValid(formValidator(translate).isValidSync(values))
          }}
        >
          {(formik) => {
            const { handleSubmit, submitForm } = formik
            submitFormHandler = submitForm
            return (
              <form onSubmit={handleSubmit} autoComplete="off">
                <Row>
                  <Col span={24}>
                    <DatePicker
                      label={translate('admin-dashboard.manage-people.termination-date')}
                      name="terminationDate"
                      id="terminationDate"
                      noStyles
                      // disabledDate={(current: Moment) =>
                      //   current.isBefore(moment(props.userToTerminate.planPeriodStartDate))
                      // }
                    />
                  </Col>
                </Row>
              </form>
            )
          }}
        </Formik>
      </div>
    </Modal>
  )
}

export default TerminateUserModal
